module.exports = __webpack_public_path__ + "static/img/acn01.37649291.png";